import { FC } from "react";
import FormFieldComponent from "../../../../../../../../common/components/form/field/form-field.component";
import InputComponent from "../../../../../../../../common/components/form/input/input.component";
import Column from "../../../../../../../../common/components/grid/column";
import Row from "../../../../../../../../common/components/grid/row";
import FormValidationResult from "../../../../../../../../common/utils/validation/types/form-validation-result";
import userTranslationsHelper from "../../../../../../../../languages/user-translations.helper";
import DriverAddCompanyFormData from "../../../form/types/driver-add-company-form-data";

type DriverAddCompanyDataProps = {
  validateCompanyData: (
    formKey: keyof DriverAddCompanyFormData,
    value?: unknown
  ) => Promise<boolean>;
  onCompanyDataChange: (
    formKey: keyof DriverAddCompanyFormData,
    value: any
  ) => void;
  companyValidationResults: Record<
    keyof DriverAddCompanyFormData,
    FormValidationResult
  >;
  companyFormValues: DriverAddCompanyFormData;
};

const DriverAddCompanyAddressComponent: FC<DriverAddCompanyDataProps> = (
  props
) => {
  const translations =
    userTranslationsHelper.getDriverAddTranslations().form.companyData;

  return (
    <>
      <Row>
        <Column xl={6}>
          <FormFieldComponent
            label={translations.address.streetLabel}
            isRequired
            classNames={{ root: "mt-0" }}
            errorMessage={props.companyValidationResults.street.errorMessage}
          >
            <InputComponent
              value={props.companyFormValues.street}
              onChange={(value) => props.onCompanyDataChange("street", value)}
              placeholder={translations.address.streetPlaceholder}
              hasError={!!props.companyValidationResults.street.errorMessage}
              onBlur={() => {
                props.validateCompanyData("street");
              }}
              idForTesting="company-data-address-street-input"
            />
          </FormFieldComponent>
        </Column>
        <Column xl={6}>
          <FormFieldComponent
            label={translations.address.houseNumberLabel}
            isRequired
            classNames={{ root: "mt-0" }}
            errorMessage={
              props.companyValidationResults.houseNumber.errorMessage
            }
          >
            <InputComponent
              value={props.companyFormValues.houseNumber}
              onChange={(value) =>
                props.onCompanyDataChange("houseNumber", value)
              }
              placeholder={translations.address.houseNumberPlaceholder}
              hasError={
                !!props.companyValidationResults.houseNumber.errorMessage
              }
              onBlur={() => {
                props.validateCompanyData("houseNumber");
              }}
              idForTesting="company-data-address-house-number-input"
            />
          </FormFieldComponent>
        </Column>
      </Row>
      <Row>
        <Column xl={6}>
          <FormFieldComponent
            label={translations.address.apartmentNumberLabel}
            errorMessage={
              props.companyValidationResults.apartmentNumber.errorMessage
            }
            classNames={{ root: "mt-0" }}
          >
            <InputComponent
              value={props.companyFormValues.apartmentNumber}
              onChange={(value) =>
                props.onCompanyDataChange("apartmentNumber", value)
              }
              placeholder={translations.address.apartmentNumberPlaceholder}
              hasError={
                !!props.companyValidationResults.apartmentNumber.errorMessage
              }
              onBlur={() => {
                props.validateCompanyData("apartmentNumber");
              }}
              idForTesting="company-data-address-apartment-number-input"
            />
          </FormFieldComponent>
        </Column>

        <Column xl={6}>
          <FormFieldComponent
            label={translations.address.townLabel}
            classNames={{ root: "mt-0" }}
            isRequired
            errorMessage={props.companyValidationResults.town.errorMessage}
          >
            <InputComponent
              value={props.companyFormValues.town}
              onChange={(value) => props.onCompanyDataChange("town", value)}
              placeholder={translations.address.townPlaceholder}
              hasError={!!props.companyValidationResults.town.errorMessage}
              onBlur={() => {
                props.validateCompanyData("town");
              }}
              idForTesting="company-data-address-town-input"
            />
          </FormFieldComponent>
        </Column>
      </Row>
      <Row>
        <Column xl={6}>
          <FormFieldComponent
            label={translations.address.zipCodeLabel}
            classNames={{ root: "mt-0" }}
            isRequired
            errorMessage={props.companyValidationResults.zipCode.errorMessage}
          >
            <InputComponent
              value={props.companyFormValues.zipCode}
              onChange={(value) => props.onCompanyDataChange("zipCode", value)}
              placeholder={translations.address.zipCodePlaceholder}
              hasError={!!props.companyValidationResults.zipCode.errorMessage}
              onBlur={() => {
                props.validateCompanyData("zipCode");
              }}
              idForTesting="company-data-address-zip-code-input"
            />
          </FormFieldComponent>
        </Column>
        <Column xl={6}>
          <FormFieldComponent
            label={translations.address.countryLabel}
            classNames={{ root: "mt-0" }}
            isRequired
            errorMessage={props.companyValidationResults.country.errorMessage}
          >
            <InputComponent
              value={props.companyFormValues.country}
              onChange={(value) => props.onCompanyDataChange("country", value)}
              placeholder={translations.address.countryPlaceholder}
              hasError={!!props.companyValidationResults.country.errorMessage}
              onBlur={() => {
                props.validateCompanyData("country");
              }}
              idForTesting="company-data-address-country-input"
            />
          </FormFieldComponent>
        </Column>
      </Row>
      <Row>
        <Column>
          <FormFieldComponent
            label={translations.address.descriptionLabel}
            classNames={{ root: "mt-0" }}
            errorMessage={
              props.companyValidationResults.description.errorMessage
            }
          >
            <InputComponent
              value={props.companyFormValues.description}
              onChange={(value) =>
                props.onCompanyDataChange("description", value)
              }
              placeholder={translations.address.descriptionPlaceholder}
              hasError={
                !!props.companyValidationResults.description.errorMessage
              }
              onBlur={() => {
                props.validateCompanyData("description");
              }}
              idForTesting="company-data-address-description-input"
            />
          </FormFieldComponent>
        </Column>
      </Row>
    </>
  );
};

export default DriverAddCompanyAddressComponent;
